import React, { useEffect, useState } from 'react';
import Modal from 'common/components/modules/modalV2'
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setBoomFiModal } from 'sites/state/modules/purchase/actions';
import Button from 'common/components/elements/buttons/primary';
import ConfirmModal from 'common/components/modules/modal-wrapper';


const BoomfiPaymentModal = ({ data, isMobile }) => {

   const dispatch = useDispatch()
   let socket = window.memberAreaSocket
   const [isOpenWarningModal, setIsOpenWarningModal] = useState(false)


   useEffect(() => {
      if(socket) {
         const handleSocket = (data) => {

            if(data?.redirect_url){
               window.location.href = data?.redirect_url
               setTimeout(() => {
                  dispatch(setBoomFiModal({ isOpen: false, data: null }))
               }, 1000)
            }
         };

         socket.removeAllListeners('boomfi-payment:redirect');
         socket.on('boomfi-payment:redirect', handleSocket);

         return () => {
            socket.off('boomfi-payment:redirect', handleSocket);
         };
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [socket]);

   const closeModal = () => {
      dispatch(setBoomFiModal({ isOpen: false, data: null }))
   }

   return (
      <>
         <Modal
            contentPosition={ isMobile ? 'bottom' : 'center' }
            contentWidth={ isMobile ? '100%' : '90%' }
            otherClassName='h-[90%] w-[90%]'
         >
            <div className='h-full w-full flex flex-col flex-1 !bg-panel'>
               <div className='flex justify-end'>
                  <Button
                     iconName='close'
                     fontIconColor='secondary'
                     darkIconColor='secondary'
                     backgroundColor='transparent'
                     onClick={ () => setIsOpenWarningModal(true) }
                     padding='none m-2 mb-0'
                     classNames='!w-8 !h-8'
                  />
               </div>
               <iframe
                  className='flex-1'
                  src={ data?.redirectLink }
                  allow='camera; microphone'
                  title='Boomfi Payment'>
               </iframe>
            </div>
         </Modal>
         {
            isOpenWarningModal &&
            <ConfirmModal
               type='confirm'
               iconSize='2xl'
               withoutCloseButton={ false }
               contentWidth='375px'
               isPreventDeafault={ false }
               isMobile={ isMobile }
               description='Closing the payment window will cancel your transaction. Please complete the payment before exiting.'
               title='Exit Payment?'
               withoutCancelButton={ false }
               icon='warning'
               iconColor='warning'
               buttonText='Continue Payment'
               textColor='secondary'
               cancelText='Cancel Payment'
               onCloseModal={ () => setIsOpenWarningModal(false) }
               cancelButtonAction={ closeModal }
               action={ () => setIsOpenWarningModal(false) }
               confirmButtonProperties={ {
                  primaryColor: true,
                  backgroundColor: '',
               } }
               buttonClassName='w-full mt-6'
               cancelButtonWrapperClassName='w-full'
               descriptionLeading='!mt-1'
            />
         }
      </>
   );
};

BoomfiPaymentModal.propTypes = {
   data: PropTypes.object,
   isMobile: PropTypes.bool,
}

export default BoomfiPaymentModal;
